export default "__VITE_PUBLIC_ASSET__484f2fd8__"